// extracted by mini-css-extract-plugin
module.exports = {"wrapper":"LogoWoW_wrapper__2G_H9","link":"LogoWoW_link__3f1eb","logo":"LogoWoW_logo__1h2vJ"};